import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csvariable(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };

return(
      <div>
      <Sides/>

      <Helmet>
 
 <title>Learn Free PHP Variables Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php variable tutorial for beginners variable in Php is a collection of similar type of data and stored in manually consecutively under one name CodeExampler provides Multiple Programming Examples for Beginners" />
 <meta name="keywords" content="codeexampler,php variable declaration,php variable declaration,php variable type,what is php variable,programming language tutorial for begineers,php variables,php variable in string" />
 <link rel="canonical" href="https://www.codeexampler.com/php-variables" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1  className="m-4 mh1" >Php Variables</h1>
    <div className="first">
       
        <a href="/php-setup"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para " >
    1, Variable is the name of a memory location in which we can store the value<br/>
    2, The variable value can be change<br/>
    3, A variable is defined by combining an identifier, data types, and an initializer.<br/>
4, The first character in the variable name must be an alphabet, underscore, a digit or,
a dollar sign. <br/>
5, All variables have a scope<br/>
6, The identifier is the name of the Variable<br/>
7, Commas or blanks do not use inside a variable name<br/>
8,Use dollar symbol($) before variable-name
    </p>
    <h2 className="mt-4 mh2">Variable Syntax in Php:</h2>



<h2 className='headings'>Php variable declaration syntax</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">{"\n"}
          <span className="qwerty-11">Type </span>
            <span className="qwerty-10">Variable Name</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-11">$ </span>
            <span className="qwerty-4">is a </span>
            <span className="qwerty-11">Type</span>
            {"\n"}
            <span className="qwerty-5">a, b and ab </span>
            <span className="qwerty-3">are a </span>

            <span className="qwerty-5">Variable Name</span>
              {"\n"} {"\n"}
              
         
          </code>
        </pre>
      </div>


<h2 className='headings'>Php variable declaration syntax Examples:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">Type </span>
            <span className="qwerty-5">Variable Name</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty">$ </span>
            <span className="qwerty-2">roll_no</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-10"> &#47;&#47;this declare a variable</span>
            {"\n"}
            <span className="qwerty">$ </span>
            <span className="qwerty-4">percentage</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-10"> &#47;&#47;this declare a variable</span>
              {"\n"} 
              <span className="qwerty">$ </span>
              <span className="qwerty-2">roll_no = </span>
              <span className="qwerty-5">40</span>
              <span className="qwerty-3">; </span>
            <span className="qwerty-10"> &#47;&#47;Assigns a variable a value</span>
              {"\n"} 
              <span className="qwerty">$ </span>
              <span className="qwerty-4">precentage = </span>
              <span className="qwerty-5">40.80</span>
              <span className="qwerty-3">; </span>
            <span className="qwerty-10"> &#47;&#47;Assigns a variable a value</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<h2 className='headings'>Declare variable in Php Rules</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">
            {"\n"}
            <span className="qwerty">$ </span>
            <span className="qwerty-4">abc</span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-10">&#47;&#47;this declare a variable</span>
            {"\n"}
            <span className="qwerty">$ </span>
            <span className="qwerty-4">abc; </span>
            <span className="qwerty-10">&#47;&#47;(abc and a_bc are a variable)</span>
              {"\n"} 
              <span className="qwerty">$</span>
              <span className="qwerty-2">a</span>
              <span className="qwerty-3">; </span>
              <span className="qwerty">$</span>
              <span className="qwerty-2">b</span>
              <span className="qwerty-3">; </span>
              <span className="qwerty">$</span>
              <span className="qwerty-2">x </span>
              <span className="qwerty">$</span>
              <span className="qwerty-2">z</span>
              <span className="qwerty-3">; </span>
            <span className="qwerty-10">&#47;&#47;(a,b,x,z) are a variable</span>
              {"\n"} 
              <span className="qwerty">$ </span>
              <span className="qwerty">a</span>
              <span className="qwerty-5">3 </span>
              <span className="qwerty-3">= "</span>
              <span className="qwerty">ram</span>
              <span className="qwerty-3">";</span>
            <span className="qwerty-10">&#47;&#47;a variable gain value ( ram )</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">Addition of variables examples</h2>


<h2 className='headings'>Q-Add 3 variables in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-4">&#60;?</span>
            <span className="qwerty-2">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-10">ab</span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-6">12</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty">$</span>
            <span className="qwerty-10">cd</span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-6">24</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty">$</span>
            <span className="qwerty-10">ef</span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-6">36</span>
            <span className="qwerty-3">; </span>
              {"\n"} 
              <span className="qwerty-11">echo </span>
              <span className="qwerty-3">(</span>
                <span className="qwerty">$</span>
              <span className="qwerty-10">ab </span>
              <span className="qwerty-3">+ </span>
              <span className="qwerty">$</span>
              <span className="qwerty-10">cd </span>
              <span className="qwerty-3">+ </span>
              <span className="qwerty">$</span>
              <span className="qwerty-10">ef</span>
              <span className="qwerty-3">); </span>
              {"\n"} 
              <span className="qwerty-3">?&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-4"> 72</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">Variable increment values in Php:
</h2>



<h2 className='headings'>Q-Add 3 variables in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-4">&#60;?</span>
                 <span className="qwerty-2">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">= </span>
            <span className="qwerty">10</span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-10">&#47;&#47; a is a variable and a is a variable</span>
              {"\n"} 
              <span className="qwerty">$</span>
              <span className="qwerty-10">a</span>
              <span className="qwerty-3">+= </span>
              <span className="qwerty">40</span>
              <span className="qwerty-3">;</span>
              {"\n"} 
              <span className="qwerty">$</span>
              <span className="qwerty-10">a</span>
              <span className="qwerty-3">= </span>
              <span className="qwerty">$</span>
              <span className="qwerty-10">a</span>
              <span className="qwerty-3"> + </span>
              <span className="qwerty">20</span>
              <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-11">echo </span>
              <span className="qwerty">$</span>
              <span className="qwerty-10">a</span>
              <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-3">?&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-2"> 70</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className='headings'>Q-Create a variable and store a no inside this variable and print output?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-3">&#60;?</span>
                 <span className="qwerty-2">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-6">40</span>
            <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-11">echo </span>
              <span className="qwerty">$</span>
              <span className="qwerty-10">a</span>
              <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-3">?&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-2"> 40</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">Create Variable String Type: </h2>



<h2 className='headings'>Q-Create a string variable and store a and b value inside string type variable and print output?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-3">&#60;?</span>
                 <span className="qwerty-2">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">="</span>
            <span className="qwerty-4">Ram</span>
            <span className="qwerty">";</span>
              {"\n"}
              <span className="qwerty">$</span>
            <span className="qwerty-10">b </span>
            <span className="qwerty-3">="</span>
            <span className="qwerty-5">Lakshman</span>
            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty-11">echo </span>
              <span className="qwerty-3">(</span>
                <span className="qwerty">$</span>
            <span className="qwerty-10">a. </span>
              <span className="qwerty-3">" " </span>
              <span className="qwerty">.$</span>
              <span className="qwerty-10">b</span>
              <span className="qwerty-3">);</span>
              {"\n"}
              <span className="qwerty-3">?&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-10"> Ram</span>
            <span className="qwerty-2"> Lakshman</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2"> Another string type example and check <a href="https://www.codeexampler.com/php-switch">switch case PHP</a></h2>


<br/>
<h2 className='headings'>Q-create a string variable and store a no inside string data type variable and print output?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-3">&#60;?</span>
                 <span className="qwerty-2">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">="</span>
            <span className="qwerty-6">Ram</span>
            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty">$</span>
            <span className="qwerty-10">b </span>
            <span className="qwerty-3">="</span>
            <span className="qwerty-5">Lakshman</span>
            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty">$</span>
            <span className="qwerty-10">c </span>
            <span className="qwerty-3">=</span>
              <span className="qwerty-3">"</span>
              <span className="qwerty-10">My Name is CodeExampler</span>
              <span className="qwerty-3"></span>
            <span className="qwerty-4"> 160208</span>
            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty-11">echo </span>
              <span className="qwerty-3">(</span>
                <span className="qwerty">$</span>
            <span className="qwerty-10">a. </span>
              <span className="qwerty-3">" " </span>
              <span className="qwerty">.$</span>
              <span className="qwerty-10">b. </span>
              <span className="qwerty-3">" " </span>
              <span className="qwerty">.$</span>
              <span className="qwerty-10">c</span>
              <span className="qwerty-3">);</span>
              {"\n"}
              <span className="qwerty-3">?&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-6"> Ram</span>
            <span className="qwerty-5"> Lakshman</span>
            <span className="qwerty-10"> My Name is CodeExampler</span>
            <span className="qwerty-4"> 160208</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">Constant:</h2>

<p className="para mt-4">Constant use when you store a value inside a variable, but after, you can’t overwrite the current value, so use constant on that place.
</p>


  <h1 className="mt-5">  </h1>
      
     
      <div className="back">
       
        <a href="/php-setup">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csvariable;